import { breakpoints, Container } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../../utils/colors";

export const Spacer = styled.div`
    margin-bottom: 50px;
     ${breakpoints.medium} {
        margin-bottom: 80px;
    }
`;

export const Outer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 32px;

    ${breakpoints.medium} {
        min-height: auto;
        margin-top: 0;
    }
`;

export const CustomContainer = styled(Container)`
    border-radius: 20px;
    ${breakpoints.medium} {
        padding: 0 50px;
    }
`;

export const Inner = styled.div`
    position: relative;
    overflow: visible;
    flex-grow: 1;
    height: 100%;
    background-color: ${colors.brandXXXLight};
    border-radius: 20px;
    padding: 30px 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column-reverse;
    gap: 0;

    ${breakpoints.medium} {
        flex-direction: row;
        border-radius: 12px;
        padding-left: 80px;
    }

    ${breakpoints.large} {
        gap: 1.5rem;
    }
`;

export const FormContainer = styled.div`
    max-width: 100%;
    width:100%;
    padding: 0 22px;

    ${breakpoints.medium} {
        max-width: 50%;
        padding: 1rem 0;
    }

    ${breakpoints.large} {
        max-width: 45%;
    }

    button:not(.popup-button){
        background-color: white !important;
    }
`;

export const Close = styled.div`
    display: flex;
    justify-content: flex-end;
    background-color: ${colors.white};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    ${breakpoints.medium} {
        background-color: transparent;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
    }
`;

export const ImageContainer = styled.div`
    width: 100%;
    position: relative;
    overflow: hidden;

    ${breakpoints.medium} {
        max-width: 50%;
    }
    ${breakpoints.large} {
        max-width: 55%;
    }

    img { 
        width: 100%;
        margin-bottom: 2rem;
        ${breakpoints.large} {
            max-height: 350px;
        }
        ${breakpoints.medium} {
            margin-bottom: 0;
            min-height: 400px;
            object-fit: cover;
            object-position: left;
        }
    }
    .medium-lower-hidden{
        display: none;
    }
    .medium-lower-visible{
        display: block;
    }
    ${breakpoints.medium} {
        .medium-lower-hidden{
            display: block;
        }
        .medium-lower-visible{
            display: none;
        }
    }

`;

export const Header = styled.div`
    padding: 0 20px;
    display: flex;
    flex-direction: column;

    > * {
        width: 100%;
        margin: 0;
    }

    ${breakpoints.large} {
        padding: 0 10rem 0 0;
    }
       
    ${breakpoints.medium} {
        align-items: center;
    } 
`;

export const Title = styled.h3`
    font-size: 25px;
    color: ${colors.brandDark};
    text-align: center;

    ${breakpoints.medium} {
        font-size: 48px;
        text-align: left;
    }
`;

export const SubTitle = styled.div`
    margin-top: 16px;
    text-align: center;

    p {
        color: ${colors.brandDark};
        font-size: 16px;

        ${breakpoints.medium} {
            font-size: 18px;
            text-align: left;
        }
    }

    strong {
        font-weight: 800;
        opacity: 1;
    }
`;

export const NoMatchError = styled.p`
    color: ${colors.brandLight};
    margin: 0;
    margin-top: 12px;
    display: flex;
    gap: 12px;
    text-align: left;
    vertical-align: middle;
    font-size: 1em;
    line-height: 1.5em;
`;

export const CheckboxLabel = styled.label`
    width: 100%;

    color: ${colors.brandDark};
    margin: 0;
    margin-top: 24px;
    display: block;
    font-size: 14px;

    input {
        margin-right: 8px;
    }
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    gap: 16px;

    > *:first-child {
        flex-grow: 1;
    }
    
    ${breakpoints.medium} {
        .popup-button { width: 215.44px; }
        flex-direction: row;
        gap: 16px;
    }

    input{
        background: #FAFBFC;
        border: 1px solid #EAEAEA;
        border-radius: 12px;
    }

    button{
        background-color: ${colors.brandMid};
    }
`;